// App version information from build process
export const gitRef = import.meta.env.VITE_GIT_REF || 'unknown'
export const gitBranch = import.meta.env.VITE_GIT_BRANCH || 'unknown'
export const gitDate = import.meta.env.VITE_GIT_DATE || 'unknown'
export const appVersion = import.meta.env.VITE_APP_VERSION || 'development'
export const gitMessage = import.meta.env.VITE_GIT_MESSAGE || 'unknown'

// Function to log version info
export function logVersionInfo() {
  const styles = [
    'background: #2c3e50',
    'color: white',
    'display: block',
    'padding: 10px',
    'font-size: 14px',
    'font-weight: bold',
  ].join(';')

  console.log('%c ScrapBoss', styles, `Version: ${appVersion}`)
}
